<div class="layout">
  <app-nav />
  <div class="content-area">
    <app-title-bar />
    @if (authService.isLoggedIn$ | async) {
      <ng-container>
        <app-content>
          <ng-container modal>
            @if (sharedService.isModalOpen$ | async) {
              <app-modal (close)="closeModal()" />
              <div class="overlay"></div>
            }
          </ng-container>
        </app-content>
      </ng-container>
    }
  </div>
  <app-loading-indicator [detectRouteTransitions]="true" />
</div>
